package presentation.screens.webPlayer

import utils.UiAction
import utils.UiState

data class WebPlayerState(
    val videoUrl: String,
    val title: String = "",
    val isLoading: Boolean = false,
    val isError: Boolean = false,
    /** Negative until the saved position is loaded. Zero means start from the beginning. */
    val resumePositionSec: Double = -1.0,
    val resumeAudio: String? = null,
    val resumeQuality: String? = null,
    val resumeSubtitles: String? = null,
    /** False until the saved voice, quality and subtitles have been read. */
    val playbackChoiceReady: Boolean = false,
) : UiState

sealed interface WebPlayerMVIAction : UiAction {

    data object OnBackPressed : WebPlayerMVIAction

    data class ProgressSample(
        val positionSec: Double,
        val durationSec: Double,
        val paused: Boolean,
    ) : WebPlayerMVIAction

    data class PlaybackChoiceChanged(
        val audio: String? = null,
        val quality: String? = null,
        val subtitles: String? = null,
    ) : WebPlayerMVIAction
}
